@use "../../styles/breakpoint.module.scss" as *;

.root {
    composes: repeater from "../../styles/layout.module.scss";
    grid-column: content;
    overflow: hidden;
}

.container {
    grid-column: content;
    position: relative;
    overflow: hidden;
    container-type: inline-size;

    --progress: 0;
}

// Width interpolates from 5-col to 6-col as --progress goes 0→1.
.cardCenter {
    display: block;
    width: calc(
        5 * (100% - 11 * var(--grid-gap)) / 12 + 4 * var(--grid-gap) +
            var(--progress) * (100% + var(--grid-gap)) / 12
    );
    aspect-ratio: 3 / 2;
    margin: 0 auto;
    border-radius: var(--border-radius-md);
    overflow: hidden;
    position: relative;
    z-index: 2;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    @media ($below-mobile) {
        width: calc(
            3 * (100% - 5 * var(--grid-gap)) / 6 + 2 * var(--grid-gap) +
                var(--progress) * (100% + var(--grid-gap)) / 6
        );
    }
}

.cardSide {
    position: absolute;
    top: 50%;
    left: calc(7 * (100% + var(--grid-gap)) / 24);
    width: calc(5 * (100% - 11 * var(--grid-gap)) / 12 + 4 * var(--grid-gap));
    aspect-ratio: 3 / 2;
    border-radius: var(--border-radius-md);
    overflow: hidden;
    backface-visibility: hidden;
    will-change: transform;
    z-index: 1;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }

    @media ($below-mobile) {
        left: calc((100% + var(--grid-gap)) / 4);
        width: calc(3 * (100% - 5 * var(--grid-gap)) / 6 + 2 * var(--grid-gap));
    }
}

.cardLeft {
    composes: cardSide;
    transform: translateY(-50%)
        translateX(calc(-1 * var(--progress) * (100cqi - var(--grid-gap)) / 4));
}

.cardRight {
    composes: cardSide;
    transform: translateY(-50%)
        translateX(calc(var(--progress) * (100cqi - var(--grid-gap)) / 4));
}
